<template>
  <div>
    <b-row>
      <b-col cols="5" class="mb-3">
        <b-row>
          <b-col cols="12">
            <b-row>
              <b-col cols="12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                  <thead>
                  <tr class="bg-gray-pale">
                    <td colspan="12" class="px-2 py-2 font-bold">Attachments</td>
                  </tr>
                  <tr>
                    <th class="px-2 py-1">#</th>
                    <th class="px-2 py-1">File Name</th>
                    <th class="px-2 py-1 float-end">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(file, idx) in application.attachments" :key="idx" style="border: solid 1px #dedede;">
                    <td class="px-2 py-1">{{idx + 1}}</td>
                    <td class="px-2 py-1 text-capitalize">{{file.fileName || cleanName(file.purpose)}}</td>
                    <td class="px-2 py-1">
                      <button class="float-end bg-gray rounded text-white hover:bg-gray-dark px-2" @click="openFile(file)">Show</button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="7">
        <CopyrightAssignmentTransferAttachments v-if="application.attachments && application.attachments.length > 0" ref="attachmentScreen"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import CopyrightAssignmentTransferAttachments from "@/views/home/services/copyright-assignment-transfer/task/CopyrightAssignmentTransferAttachments.vue";
import server from "@/app/env/server.json";

export default {
  name: "CopyrightAssignmentTransferFormFilesEscalated",
  components: {CopyrightAssignmentTransferAttachments},
  props:{
    application:Object
  },
  data(){
    return{
      attachmentUrl:null
    }
  },
  mounted() {
    if (this.application && this.application.attachments && this.application.attachments.length > 0) {
      this.openFile(this.application.attachments[0])
    }
  },
  methods:{
    dateFormat(date){
      return moment(date).format("DD-MM-YYYY")
    },
    openFile(data){
      if (data && data.fileLink) {
        this.attachmentUrl = data.fileLink
      } else {
        let fName = data && data.attachment ? data.attachment.trim() : ""
        this.attachmentUrl = server.IP+"/copy-right/api/v1/applications/downloads?attachment="+fName
      }
      if (this.$refs.attachmentScreen) {
        this.$refs.attachmentScreen.openFile(this.attachmentUrl)
      }
    },
    cleanName(name){
      if (!name) return "";
      let n = name.replaceAll("_", " ")
      return n.toLowerCase()
    },
  },
}
</script>

<style scoped>
th, td{
  font-size: 12px;
}
</style>
